import { render, staticRenderFns } from "./cell-translation-job-language.vue?vue&type=template&id=22e7c16e&scoped=true"
import script from "./cell-translation-job-language.ts?vue&type=script&lang=ts&external"
export * from "./cell-translation-job-language.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-translation-job-language.vue?vue&type=style&index=0&id=22e7c16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e7c16e",
  null
  
)

export default component.exports